// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CameraIcon = ({ fill = "#2BB792" }: any) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill={fill} />
        <path
            d="M20 5h-3.17l-1.24-1.35A1.99 1.99 0 0 0 14.12 3H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z"
            fill={fill}
        />
    </svg>
)

export default CameraIcon
